// extracted by mini-css-extract-plugin
export default {"row":"Details_row__hg2ZE","column":"Details_column__YEhao","title":"Details_title__0p9Yl","date":"Details_date__Sw2oI","highlight":"Details_highlight__MTdD2"};